module.exports = __webpack_public_path__ + "img/coupon_header.ffa0a1cf.png";